import React from 'react'

export const MOBILE_BANNER_MAX_WIDTH = 767.98

const getIsMobileViewport = () => (
  typeof window !== 'undefined' && window.innerWidth <= MOBILE_BANNER_MAX_WIDTH
)

const useBannerViewport = () => {
  const [isMobile, setIsMobile] = React.useState(getIsMobileViewport)

  React.useEffect(() => {
    const handleResize = () => setIsMobile(getIsMobileViewport())

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return isMobile
}

export default useBannerViewport
